import React from 'react';
import PropTypes from 'prop-types';
import {
  useBreakpoint,
  Pagination,
  PaginationDisplayedItemCount
} from '@one-thd/sui-atomic-components';

const PaginationWrapper = ({
  listLength, pageSize, page, onPageChanged, scrollContainer
}) => {
  const totalPages = Math.ceil(listLength / pageSize);
  const matches = useBreakpoint('sm');

  const handlePageChanged = (event, value) => {
    event.preventDefault();
    if (scrollContainer) {
      const anchor = document.querySelector(scrollContainer);
      try {
        // Added a small delay for navigating from page 2 to 1 using previous btn
        // To avoid events conflict
        setTimeout(() => anchor.scrollIntoView({ behavior: 'smooth' }), 50);
      } catch (err) {
        /* */
      }
    }
    if (onPageChanged) {
      const { href } = window.location;
      const urlObj = new URL(href);
      const { pathname, searchParams } = urlObj;
      const params = new URLSearchParams(searchParams);
      if (value > 1) {
        params.set('Nao', pageSize * (value - 1));
      } else {
        params.delete('Nao');
      }
      onPageChanged(`${pathname}?${params.toString()}`);
    }
  };

  if (!listLength) {
    return null;
  }
  return (
    <div className="sui-grow">
      <div
        className="sui-relative
      sui-flex
      sui-items-center
      sui-gap-4 sui-flex-col-reverse
      sm:sui-flex-row
      sm:sui-gap-0"
        data-testid="pagination-range"
      >
        <PaginationDisplayedItemCount page={page} itemsPerPage={pageSize} items={listLength} />
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChanged}
          fullWidth={matches.lesser}
          siblingCount={matches.lesser ? 0 : 1}
        />
      </div>
    </div>
  );
};

PaginationWrapper.propTypes = {
  listLength: PropTypes.number,
  pageSize: PropTypes.number,
  page: PropTypes.number,
  onPageChanged: PropTypes.func,
  scrollContainer: PropTypes.string
};

PaginationWrapper.defaultProps = {
  listLength: 0,
  pageSize: 15,
  page: 1,
  onPageChanged: () => {},
  scrollContainer: 'html'
};

export default PaginationWrapper;
